__turbopack_context__.v({
  "active": "bnNp3q_active",
  "container": "bnNp3q_container",
  "tab": "bnNp3q_tab",
  "tabBar": "bnNp3q_tabBar",
  "tabCount": "bnNp3q_tabCount",
  "tabIcon": "bnNp3q_tabIcon",
  "tabLabel": "bnNp3q_tabLabel",
});
